export default __webpack_public_path__ + "static/media/settingsIcon.912c0155.svg";